import { Status } from '../lib/constants'
import { statusHelper } from './helpers/login'
import { logSending } from './helpers/loger'
import { logger } from '../helpers/logger'
const END_MESSAGE = "\r\n"

export class WS {
  constructor(WS_URL, receiveMessage, name, handleErrorText) {
    this.websocket = null
    this.WS_URL = WS_URL
    this.receiveMessage = receiveMessage
    this.name = name
    this.reconnectTimeout = 0
    this.pingInterval = 0
    this.count = 0
    this.msgBuffer = ''
    this.handleErrorText = handleErrorText
  }
  start() {
    logger.log(`%cStart websocket to ${this.WS_URL}`, 'color:brown')
    this.websocket = new WebSocket(this.WS_URL)
    this.websocket.onopen = evt => this.onopen(evt)
    this.websocket.onmessage = evt => this.onReceiveMessage(evt)
    this.websocket.onclose = evt => this.onerror(evt)
    this.websocket.onerror = evt => this.onerror(evt)
    return this
  }

  onReceiveMessage(evt) {
    try {
      var msg = evt.data
      this.msgBuffer += msg
      if (this.msgBuffer.indexOf(END_MESSAGE) !== -1) {
        var splited = this.msgBuffer.split(END_MESSAGE)
        splited.forEach((item) => {
          if (item.length > 0) {
            this.receiveMessage(JSON.parse(item))
          }
        })
        this.msgBuffer = splited[splited.length - 1]
      }
      // if (JSON.parse(msg).service === 'ping') return this.count = 0
    } catch (error) {
      logger.log(evt.data)
      logger.log(error)
    }
  }

  sendMessage(msg) {
    const parsed = JSON.parse(msg);
    if (parsed.service !== 'ping' && parsed.service !== 'jackpot') {
      this.count = 0
    }
    logSending(msg)
    if (this.websocket.readyState === WebSocket.OPEN) this.websocket.send(msg)
  }

  onopen() {
    this.setStatus(Status.CONNECTED)
    this.pingInterval = setInterval(
      this.pingIntervalFunc.bind(null, this),
      5000,
    )
  }
  pingIntervalFunc(self) {
    const msg = JSON.stringify({ service: "ping", data: {} })
    self.count++
    if (self.count === 60) {
      self.disconnect()
    }
    self.sendMessage(msg)
  }

  onerror() {
    this.setStatus(Status.DISCONNECTED)
    clearTimeout(this.reconnectTimeout)
    clearInterval(this.pingInterval)
  }

  disconnect() {
    clearInterval(this.pingInterval)
    clearTimeout(this.reconnectTimeout)
    this.setStatus(Status.DISCONNECTED)

    this.websocket.onerror = null
    this.websocket.onopen = null
    this.websocket.onReceiveMessage = null
    this.websocket.onclose = null
    this.websocket.close()
  }

  setStatus(status) {
    statusHelper(status, this, this.handleErrorText)
  }
}